import { useContext } from 'react'
import { PaymentCaseContext } from 'contexts/paymentCaseContext'

export const usePaymentCaseContext = () => {
  return useContext(PaymentCaseContext)
}
